export default __webpack_public_path__ + "static/media/scarabknight.73b63dfc.png";